export default "__VITE_ASSET__wOD6XlUr__"